import { donationModal } from "./donationModal"
import { ui } from "./ui"
import { hubspotModal } from "./hubspotModal"
import { mailchimpModal } from "./mailchimpModal"

export default {
  donationModal,
  hubspotModal,
  mailchimpModal,
  ui,
}
